import { getApiBaseUrl } from '../services/api';
import medicalClinicsImg from '../assets/homepageimages/Medical-Clinics.webp';
import surgeryClinicImg from '../assets/homepageimages/surgery-clinic.webp';
import diagnosticServicesImg from '../assets/homepageimages/diagnostic-services.webp';
import emergencyServiceImg from '../assets/homepageimages/emergency-service.webp';

const SERVICE_IMAGES_BY_NAME = {
  'medical clinics': medicalClinicsImg,
  'surgical clinics': surgeryClinicImg,
  'diagnostic services': diagnosticServicesImg,
  'emergency services': emergencyServiceImg,
};

const LEGACY_PUBLIC_PATHS = {
  '/Medical-Clinics.jpg': medicalClinicsImg,
  '/Medical-Clinics.webp': medicalClinicsImg,
  '/surgery-clinic.jpg': surgeryClinicImg,
  '/surgery-clinic.webp': surgeryClinicImg,
  '/diagnostic-services.jpg': diagnosticServicesImg,
  '/diagnostic-services.webp': diagnosticServicesImg,
  '/emergency-service.jpg': emergencyServiceImg,
  '/emergency-service.webp': emergencyServiceImg,
};

export const getServiceImageUrl = (service) => {
  if (!service) return medicalClinicsImg;

  if (service.imageId) {
    return `${getApiBaseUrl()}/images/${service.imageId}`;
  }

  if (service.image) {
    if (service.image.startsWith('http') || service.image.includes('/api/images/')) {
      return service.image;
    }
    if (LEGACY_PUBLIC_PATHS[service.image]) {
      return LEGACY_PUBLIC_PATHS[service.image];
    }
  }

  const byName = SERVICE_IMAGES_BY_NAME[(service.name || '').trim().toLowerCase()];
  return byName || medicalClinicsImg;
};

export const DEFAULT_SERVICE_ROUTES = {
  'medical clinics': '/services/medical-clinics',
  'surgical clinics': '/services/surgical-clinics',
  'diagnostic services': '/services/diagnostic-services',
  'emergency services': '/services/emergency-services',
};

export const getServiceRoute = (service) => {
  if (service?.route && service.route !== '/services') {
    return service.route;
  }
  return DEFAULT_SERVICE_ROUTES[(service?.name || '').trim().toLowerCase()] || '/services';
};

/** Fixed four services shown on the home page (always in this order). */
export const FEATURED_HOME_SERVICES = [
  {
    id: '1',
    name: 'Medical Clinics',
    description:
      'Comprehensive healthcare services delivered by experienced physicians across various medical specialties.',
    icon: 'medical_services',
    route: '/services/medical-clinics',
    image: medicalClinicsImg,
  },
  {
    id: '2',
    name: 'Surgical Clinics',
    description:
      'Advanced surgical procedures performed by expert surgeons using cutting-edge technology and techniques.',
    icon: 'healing',
    route: '/services/surgical-clinics',
    image: surgeryClinicImg,
  },
  {
    id: '3',
    name: 'Diagnostic Services',
    description:
      'State-of-the-art diagnostic testing and imaging services for accurate medical assessments.',
    icon: 'biotech',
    route: '/services/diagnostic-services',
    image: diagnosticServicesImg,
  },
  {
    id: '4',
    name: 'Emergency Services',
    description:
      '24/7 emergency care with rapid response teams and advanced life support capabilities.',
    icon: 'emergency',
    route: '/services/emergency-services',
    image: emergencyServiceImg,
  },
];
